<template>
	<header class="gridx">
		<vs-navbar
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar"
      text-color="rgba(255,255,255,0.7)"
      active-text-color="rgba(255,255,255,1)"
    >
      <!---
      Template logo
      --> 
      <div slot="title" class="themelogo">
        <img class="logosize" src='@/assets/images/logo/logohbv.png' />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>
      <!---
      Mobile toggle
      --> 
      <div slot="title">
        <div class="hiddenDesktop cursor-pointer" @click.stop="activeSidebar">
          <vs-icon icon="mdi-menu" icon-pack="mdi"></vs-icon>
        </div>
      </div>
      <!---
      Craete new dd
      -->   
<!--      <vs-button color="danger" href="https://www.wrappixel.com" type="filled">Upgrade to Pro</vs-button>-->

      <vs-spacer></vs-spacer>
    
      <!---
      Create new dd
      -->   
     
        
        
      <!---
      Craete new dd
      -->   
      
      <!---
      Craete new dd
      
      <vs-dropdown  vs-trigger-click left class="cursor-pointer pr-2 pl-2 ml-1 mr-md-3">
         <a class="text-white-dark user-image" href="#">
           <img src="@/assets/images/users/img33.png" alt="User"/>
         </a> 
      
        <vs-dropdown-menu class="topbar-dd">       <!--, params: {id: this.obj.id}
            <vs-dropdown-item :to="{name: 'profile'}"><vs-icon icon="person_outline" class="mr-1"></vs-icon>Profil</vs-dropdown-item>
         
        </vs-dropdown-menu>
      </vs-dropdown>-->  
      
    </vs-navbar>
     
	</header>

</template>

<script>
  export default {
    name : 'Navbar',
   
    props: {
        topbarColor: {
            type: String,
            default: "#ee313a",
        },
        title: {
              type: String,
        },
        logo: {
            type: String
        },
    },
    data:()=>({
       //obj: new User(),
        ney :"ney",
      indexActive: 0,
      showToggle: false
    }),

    methods: {
        //This is for sidebar trigger in mobile
        activeSidebar() {
            this.$store.commit('IS_SIDEBAR_ACTIVE', true);
        }
    }
  }
</script>
